import ProjectSession from "../../../model2/project/project-session";


export default function selectParent_ExpandAll(rootProjects:ProjectSession[]): void {


    const recursiveExpand = (project:ProjectSession) => {

        project.treeIsExpandedProjectSelector = true

        _.map(project.treeChildren, (childProject: ProjectSession) => {
            recursiveExpand(childProject)
        })

    }

    _.map(rootProjects, (project: ProjectSession) => {
        recursiveExpand(project)
    })

}